import { getI18n } from "./get-i18n";

type InterpolationValue = string | number | boolean | null | undefined;

const resolvePath = (path: string): unknown => {
  const chunks = path.split(".");
  let current: unknown = getI18n();

  for (const chunk of chunks) {
    if (typeof current !== "object" || current === null || !(chunk in current)) {
      return undefined;
    }
    current = (current as Record<string, unknown>)[ chunk ];
  }

  return current;
};

const interpolate = (template: string, vars?: Record<string, InterpolationValue>): string => {
  if (!vars) return template;

  return template.replace(/\{\{\s*([\w.-]+)\s*\}\}/g, (_, key: string) => {
    const value = vars[ key ];
    return value === undefined || value === null ?
      "" :
      String(value);
  });
};

export const t = (key: string, vars?: Record<string, InterpolationValue>): string => {
  const resolved = resolvePath(key);
  if (typeof resolved !== "string") return key;
  return interpolate(resolved, vars);
};
